export default "__VITE_ASSET__CYVu_pJJ__"